import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { SharedModule } from 'src/app/core/shared.module';
import { Feature } from 'src/app/models/subscription-plan';
import { navigateToUpgrade } from 'src/app/store/subscription/subscription.helpers';
import { VButtonComponent } from '../../ui-kit/buttons/button/button.component';

@Component({
  selector: 'app-not-available-in-plan',
  templateUrl: './not-available-in-plan.component.html',
  imports: [VButtonComponent, SharedModule],
})
export class NotAvailableInPlanComponent {
  router = inject(Router);
  private store = inject(Store);

  readonly feature = input<Feature>();

  goToPlans() {
    navigateToUpgrade(this.router, this.store);
  }
}
